var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_vm._l((_vm.groupedByDate),function(surveys,date){return [_c('survey-list-date',{attrs:{"date":date,"tasks":surveys}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }